import RangeSlider from './RangeSlider';

// export types
export type { RangeSliderProps } from './RangeSlider';

// export components
export { RangeSlider };
export default RangeSlider;
